import YFormPostCategoryPicker from './PostCategoryPicker';

export { YFormPostCategoryPicker };
export default YFormPostCategoryPicker;
